import { useCallback, useMemo } from "react";
import type { Lodging } from "@b2bportal/lodging-api";
import {
  performCancellationFilter,
  performHomeAmenitiesFilter,
  performHomesRoomsAndBedsFilter,
  performHotelNameFilter,
  performMealPlanFilter,
  performPayLaterFilter,
  performPriceFilter,
  performStarRatingFilter,
  performStayTypeFilter,
  performAmenitiesFilter,
  useHotelsAvailabilityFilters,
  performUserRatingFilter,
} from "@tenant/hotels";
import { useHotelsConfig } from "../../../context/HotelsConfigContext";
import { performAvailabilityFilter } from "../../../utilities/filtersHelpers";

export const usePerformFilterOnHotelList = () => {
  const { context: filterContent } = useHotelsAvailabilityFilters();
  const config = useHotelsConfig();

  const performFilter = useCallback(
    (hotel: Lodging) => {
      return (
        performAvailabilityFilter(
          hotel,
          config.filterUnavailableLodgings ?? false
        ) &&
        performStarRatingFilter(hotel, filterContent.starRating) &&
        performPriceFilter(
          hotel,
          filterContent.hasSetPriceFilterSelector,
          filterContent.priceRange
        ) &&
        performCancellationFilter(hotel, filterContent.freeCancellation) &&
        performAmenitiesFilter(
          hotel,
          filterContent.amenities,
          filterContent.stayType
        ) &&
        performPayLaterFilter(hotel, filterContent.payLater) &&
        performHotelNameFilter(hotel, filterContent.hotelName) &&
        performMealPlanFilter(hotel, filterContent.mealPlan) &&
        performStayTypeFilter(hotel, filterContent.stayType) &&
        performHomesRoomsAndBedsFilter(
          hotel,
          filterContent.homeRoomsAndBeds,
          filterContent.stayType
        ) &&
        performHomeAmenitiesFilter(
          hotel,
          filterContent.homeAmenities,
          filterContent.stayType
        ) &&
        performUserRatingFilter(hotel, filterContent.userRating)
      );
    },
    [
      config.filterUnavailableLodgings,
      filterContent.amenities,
      filterContent.freeCancellation,
      filterContent.hasSetPriceFilterSelector,
      filterContent.homeAmenities,
      filterContent.homeRoomsAndBeds,
      filterContent.hotelName,
      filterContent.mealPlan,
      filterContent.payLater,
      filterContent.priceRange,
      filterContent.starRating,
      filterContent.stayType,
      filterContent.userRating,
    ]
  );

  return useMemo(() => ({ handlers: { performFilter } }), [performFilter]);
};
